module.exports = __webpack_public_path__ + "img/up.19fa96f0.svg";